import { createContext, useCallback, useContext, useEffect, useState } from 'react';
import api from '../api/axios';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [usuario, setUsuario] = useState(null);
  const [carregando, setCarregando] = useState(true);

  const sair = useCallback(() => {
    localStorage.removeItem('access_token');
    localStorage.removeItem('refresh_token');
    setUsuario(null);
  }, []);

  // O interceptor do axios dispara este evento quando o refresh falha.
  useEffect(() => {
    window.addEventListener('auth:logout', sair);
    return () => window.removeEventListener('auth:logout', sair);
  }, [sair]);

  // Restaura a sessão no boot
  useEffect(() => {
    const token = localStorage.getItem('access_token');
    if (!token) {
      setCarregando(false);
      return;
    }
    api
      .get('/auth/me')
      .then((r) => setUsuario(r.data))
      .catch(() => sair())
      .finally(() => setCarregando(false));
  }, [sair]);

  const entrar = useCallback(async (email, senha) => {
    const { data } = await api.post('/auth/login', { email, senha });
    localStorage.setItem('access_token', data.access_token);
    localStorage.setItem('refresh_token', data.refresh_token);
    const me = await api.get('/auth/me');
    setUsuario(me.data);
    return me.data;
  }, []);

  return (
    <AuthContext.Provider
      value={{
        usuario,
        carregando,
        entrar,
        sair,
        isAdmin: usuario?.perfil === 'admin',
        // Gestor ou admin — quem pode gerenciar usuários.
        isGestor: usuario?.perfil === 'admin' || usuario?.perfil === 'gestor',
      }}
    >
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
